import fr from './translations/fr';
import en from './translations/en';

export const translations = {
  fr,
  en,
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧', nativeName: 'English' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', nativeName: 'Français' },
];

export const defaultLanguage = 'en';

export default translations;